import React from 'react';
import {Redirect} from 'react-router-dom';
import {FuseUtils} from '@fuse/index';
import {ExampleConfig} from 'main/content/example/ExampleConfig';
import {PengaturanConfig} from 'main/content/Pengaturan/PengaturanConfig';
import {InstrumenConfig} from 'main/content/Instrumen/InstrumenConfig';
import {LoginConfig} from 'main/content/login/LoginConfig';
import {ValidasiConfig} from 'main/content/Validasi/ValidasiConfig';
import {RaporMutuConfig} from 'main/content/RaporMutu/RaporMutuConfig';
import { NotifikasiConfig } from '../main/content/Notifikasi/NotifikasiConfig';

const routeConfigs = [
    ExampleConfig,
    LoginConfig,
    PengaturanConfig,
    InstrumenConfig,
    ValidasiConfig,
    RaporMutuConfig,
    NotifikasiConfig
];

export const routes = [
    ...FuseUtils.generateRoutesFromConfigs(routeConfigs),
    {
        path     : '/',
        component: () => <Redirect to="/Beranda"/>
    }
];



// WEBPACK FOOTER //
// ./src/fuse-configs/fuseRoutesConfig.js